import { render, staticRenderFns } from "./SlideButton.vue?vue&type=template&id=6f374508&scoped=true"
import script from "./SlideButton.vue?vue&type=script&lang=js"
export * from "./SlideButton.vue?vue&type=script&lang=js"
import style0 from "./SlideButton.vue?vue&type=style&index=0&id=6f374508&prod&lang=scss&scoped=true"
import style1 from "./SlideButton.vue?vue&type=style&index=1&id=6f374508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f374508",
  null
  
)

export default component.exports